var throttle = require('lodash.throttle');

(function ($) {
	var $sidebars = $('.js-sticky-sidebar');

	if ($sidebars.length === 0 || $sidebars.is(':visible') === false) {
		return;
	}

	$sidebars.each(function () {
		var $sidebar = $(this);
		var sidebarWidth = $sidebar.data('sticky-width') || $sidebar.outerWidth();

		var footerTop = $('.footer-section').offset().top;
		var offset = $sidebar.data('sticky-offset') || 30;
		var sidebarTop;
		var onDesktop = window.innerWidth > 1140;
		var onReportStartPage = document.querySelector('.report-page--start-page');
		var isNotReportTheme3 = document.querySelector('.report-theme-3') == null ;

		$(window).on('load', function() {
			sidebarTop = $sidebar.offset().top;
		});

		var setStickyState = function () {
			var scrollTop = $(window).scrollTop();
			var bannerIsPresent = document.querySelector('.banner-level-2');
			var bannerHeight = 0;
			footerTop = $('.footer-section').offset().top;

			if (onReportStartPage && onDesktop && bannerIsPresent && isNotReportTheme3) {
				bannerHeight = $('.report-page--start-page .banner-level-2').first().outerHeight(true);
			}

			var hasScrolledToFooter = scrollTop + $sidebar.height() + offset > footerTop;
			var hasScrolledToSidebar = scrollTop + offset > sidebarTop + bannerHeight;

			if (hasScrolledToFooter) {
				$sidebar.css({
					'position': 'absolute',
					'top': 'auto',
					'bottom': offset,
					'width': sidebarWidth
				});
			} else if (hasScrolledToSidebar) {
				$sidebar.css({
					'position': 'fixed',
					'top': offset,
					'bottom': 'auto',
					'width': sidebarWidth
				});

				$sidebar.addClass('is-sticky-on');
			} else {
				$sidebar.css({
					'position': 'relative',
					'top': bannerHeight
				});
				$sidebar.removeClass('is-sticky-on');
			}
		};

		$(window).on('scroll', throttle(setStickyState, 50, { trailing: true, leading: true }));

		$(window).on('load', function() {
			setStickyState();
		});
	});
})(jQuery);
